class BrowserService {
  static getDomainName() {
    return window.location.hostname.split('.').slice(-1)[0]
  }
}

export default BrowserService
